import { eventBus, VERIFIED_CONNECTION_MILESTONES } from "@kubera/common";

import { ANALYTICS } from "analytics";
import { TrackAnalytics } from "utilities/TrackAnalytics";
import { metaPixelEvents, trackMetaPostSignupEvent } from "utilities/MetaPixel";

const META_SETUP_EVENT_BY_MILESTONE = {
  1: metaPixelEvents.SETUP_1,
  3: metaPixelEvents.SETUP_3
};

export const TrackVerifiedConnectionsInit = () => {
  eventBus.addEventListener("any", event => {
    const { eventName, data } = event.detail;

    if (eventName !== "verifiedConnectionMilestone") {
      return;
    }

    const [milestone, user, preferences] = data;
    if (VERIFIED_CONNECTION_MILESTONES.includes(milestone) === false) {
      return;
    }

    TrackAnalytics({
      category: ANALYTICS.CATEGORY.USER,
      action: `${ANALYTICS.ACTION.VERIFIED_CONNECTED}_${milestone}`
    });

    const metaEvent = META_SETUP_EVENT_BY_MILESTONE[milestone];
    if (metaEvent && user) {
      trackMetaPostSignupEvent(user, preferences, metaEvent);
    }
  });
};
